import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ReciprocalChargeModalComponent } from './reciprocal-charge-modal.component';

export interface ReciprocalChargeModalResult {
  reciprocalVenueId: string;
  reciprocalMemberName: string;
  reciprocalMemberNumber: string;
}

@Injectable()
export class ReciprocalChargeModalController {
  constructor(private modalCtrl: ModalController) {}

  async show(options: {
    reciprocalVenueOptions: { id: string; name: string }[];
    initialVenueId?: string;
    initialMemberName?: string;
    initialMemberNumber?: string;
  }): Promise<ReciprocalChargeModalResult | undefined> {
    const modal = await this.modalCtrl.create({
      component: ReciprocalChargeModalComponent,
      cssClass: 'reciprocal-charge-modal',
      componentProps: {
        reciprocalVenueOptions: options.reciprocalVenueOptions,
        initialVenueId: options.initialVenueId ?? '',
        initialMemberName: options.initialMemberName ?? '',
        initialMemberNumber: options.initialMemberNumber ?? '',
      },
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }
}
